export const getTeamMembersListIdByParams = (params) => {
    const idString = Object.entries(params)
        .map(([key, value]) => `${key}-${value}`)
        .join('_');

    return idString;
}